export default class ExtensionOption {
    id: number;
    contractLookupId?: number;
    optionTerm?: number;
    optionUnitTypeId?: number;
    optionAmount?: number;
    optionFeeTypeId?: number;
    optionTotal?: number;
    prepaidOption?: boolean;
}


// WEBPACK FOOTER //
// ./src/models/ExtensionOption.ts